import React, { Suspense } from 'react';

const IntroWidgetAnchor = React.lazy(() => {
  return import('@amzn/intro-widgets-api').then((module) => ({
    default: module.IntroWidgetAnchor,
  }));
});

export const SuspenseIntroWidgetAnchor = (props) =>
  props?.id ? (
    <Suspense fallback={null}>
      <IntroWidgetAnchor {...props} />
    </Suspense>
  ) : null;
